import { isInappEnv, SiteEnv } from '@pubstack/common/src/site'
import { FunctionComponent } from 'react'
import { Flyout } from '~/components/Flyout'

export const SitePageHelpFlyout: FunctionComponent<{ siteEnv?: SiteEnv }> = ({ siteEnv }) => {
  const isInapp = siteEnv ? isInappEnv(siteEnv) : false

  return (
    <Flyout.Content>
      <Flyout.Title>Help</Flyout.Title>
      <Flyout.Body>
        <div className="flex flex-col gap-6">
          <h2>How to monetise {isInapp ? 'an app' : 'a media'}?</h2>
          <div className="flex flex-col">
            <p>1. Create all elements listed in “Activation” tab.</p>
            {isInapp ? (
              <p>
                2. Make sure to initialize the Prebid Mobile SDK with your Prebid Server configuration and define your ad units accordingly in the app. You can find more information in the
                documentation and code examples in the “Connect to Pubstack” tab.
              </p>
            ) : (
              // `pbjs.config` is not a Prebid API: the ad units are connected through the bids of each ad unit,
              // which is the snippet the "Connect to Pubstack" tab hands out.
              <p>
                2. Make sure to have the server-side configuration in pbjs.setConfig, and the Pubstack bid on every ad unit you want monetised. You can find more information and scripts in “Connect to
                Pubstack” tab.
              </p>
            )}
            {/* A stack is created "Ready to deploy"; nothing serves until it is deployed. */}
            <p>3. Create a Default stack and deploy it. Your media is now monetised.</p>
          </div>
        </div>
      </Flyout.Body>
    </Flyout.Content>
  )
}
